<script lang="ts" setup>
import { provideScrollWrapperContext } from './model';

provideScrollWrapperContext();
</script>
<template>
  <div class="overflow-auto rounded-lg border border-gray-200 dark:border-navy-600">
    <slot />
  </div>
</template>
